import { render, staticRenderFns } from "./AditionalEditForm.vue?vue&type=template&id=2a53b6a9&scoped=true"
import script from "./AditionalEditForm.vue?vue&type=script&lang=js"
export * from "./AditionalEditForm.vue?vue&type=script&lang=js"
import style0 from "./AditionalEditForm.vue?vue&type=style&index=0&id=2a53b6a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a53b6a9",
  null
  
)

export default component.exports